import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const Mute: React.FC<SvgProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M17.25 9.75L19.5 12M19.5 12L21.75 14.25M19.5 12L21.75 9.75M19.5 12L17.25 14.25M6.75 8.25L11.47 3.53C11.5749 3.42524 11.7085 3.35392 11.8539 3.32503C11.9993 3.29615 12.15 3.311 12.2869 3.36771C12.4239 3.42442 12.541 3.52045 12.6234 3.64367C12.7058 3.76688 12.7499 3.91176 12.75 4.06V19.94C12.7499 20.0882 12.7058 20.2331 12.6234 20.3563C12.541 20.4795 12.4239 20.5756 12.2869 20.6323C12.15 20.689 11.9993 20.7038 11.8539 20.675C11.7085 20.6461 11.5749 20.5748 11.47 20.47L6.75 15.75H4.51C3.63 15.75 2.806 15.243 2.572 14.396C2.35751 13.6154 2.2492 12.8095 2.25 12C2.25 11.17 2.362 10.367 2.572 9.604C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
